import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { ArrowForward } from '@mui/icons-material';

import NextLink from '../NextLink';
import { colors } from '../../constants/styleConstants';
import styles from './ViewDetailsLink.module.scss';

const useStyles = makeStyles()({
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 5,
    color: colors.blueChip,
    margin: '0 -12px',
    cursor: 'pointer',
    '&:hover': {
      color: colors.blueChip,
    },
  },
  arrowIcon: {
    marginLeft: 14,
    fontSize: 18,
    color: colors.blueChip,
    '&:hover': {
      color: colors.blueChip,
    },
  },
});

const ViewDetailsLink = ({ linkText, linkProps, className, onClick, trackLink }) => {
  const { classes, cx } = useStyles();

  return onClick ? (
    <div className={cx(classes.linkBox, className)} onClick={onClick}>
      <span className={styles.linkText}>{linkText}</span>
      <ArrowForward className={classes.arrowIcon} />
    </div>
  ) : (
    <NextLink className={cx(classes.linkBox, className)} trackLink={trackLink} {...linkProps}>
      <span className={styles.linkText}>{linkText}</span>
      <ArrowForward className={classes.arrowIcon} />
    </NextLink>
  );
};

ViewDetailsLink.propTypes = {
  linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
  linkText: PropTypes.string,
  icon: PropTypes.node,
  trackLink: PropTypes.func,
};

export default ViewDetailsLink;
